import { render, staticRenderFns } from "./AgentLogin.vue?vue&type=template&id=3e96555a&scoped=true&"
import script from "./AgentLogin.vue?vue&type=script&lang=js&"
export * from "./AgentLogin.vue?vue&type=script&lang=js&"
import style0 from "./AgentLogin.vue?vue&type=style&index=0&id=3e96555a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e96555a",
  null
  
)

export default component.exports